import { RouteObject } from "react-router";

import { clientsRoutes } from "../client/routes";
import { paymentRoutes } from "../payment/routes";
import { courseRoutes } from "../settings/course/routes";
import { protocolRoutes } from "../settings/protocol/routes";
import { settingsRoutes } from "../settings/routes";
import { userRoutes } from "../user/routes";

export const adminRoutes: RouteObject[] = [
    {
        path: "admin",
        children: [
            ...clientsRoutes,
            ...userRoutes,
            ...protocolRoutes,
            ...courseRoutes,
            ...paymentRoutes,
            ...settingsRoutes,
        ],
    },
];
